module.exports = __webpack_public_path__ + "static/media/cascade_disable.d7c811e0.svg";